export const apiUrl = process.env.REACT_APP_API_URL;

export const scrollTriggerHeight = 100;
